import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#8D8D94",
  d: "m8 8.703 2.049 2.049q.138.139.348.141a.47.47 0 0 0 .354-.141.48.48 0 0 0 .145-.352.48.48 0 0 0-.145-.351L8.703 8l2.048-2.048a.48.48 0 0 0 .142-.348.47.47 0 0 0-.142-.355.48.48 0 0 0-.351-.145.48.48 0 0 0-.351.145L8 7.298 5.951 5.249a.48.48 0 0 0-.348-.142.47.47 0 0 0-.354.142.48.48 0 0 0-.145.351q0 .207.145.352L7.297 8 5.25 10.05a.48.48 0 0 0-.142.348.47.47 0 0 0 .142.355.48.48 0 0 0 .351.144.48.48 0 0 0 .351-.144zm.001 5.63a6.2 6.2 0 0 1-2.47-.498 6.4 6.4 0 0 1-2.011-1.354 6.4 6.4 0 0 1-1.354-2.01 6.2 6.2 0 0 1-.5-2.47q0-1.314.5-2.47A6.4 6.4 0 0 1 3.518 3.52a6.4 6.4 0 0 1 2.01-1.354A6.2 6.2 0 0 1 8 1.667q1.314 0 2.47.499 1.156.498 2.011 1.353t1.354 2.01q.5 1.156.5 2.47t-.5 2.47a6.4 6.4 0 0 1-1.353 2.012 6.4 6.4 0 0 1-2.01 1.354 6.2 6.2 0 0 1-2.47.499"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }